import { CallApiGetUser } from "../../Api/Enforcement";
import { ShowCustomErrorModal } from "../../Components/Atoms/CustomErrorModal";
import {
  getClientVerifyPromise,
  handleClearStoredAuth,
  handleGetProfile,
  rememberVerifiedClientUser,
  setClientVerifyPromise,
} from "./Storage";

function isLoggedInUser(res) {
  return Boolean(res?.AccountName) && !res?.Status;
}

let verifiedForPath = null;

export function verifyClientSession({ force = false } = {}) {
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const pathChanged = verifiedForPath !== path;

  if (!force && !pathChanged) {
    const existing = getClientVerifyPromise();
    if (existing) return existing;
  }

  verifiedForPath = path;
  const hadCachedProfile = Boolean(handleGetProfile()?.AccountName);

  const promise = new Promise((resolve) => {
    CallApiGetUser((res) => {
      if (isLoggedInUser(res)) {
        rememberVerifiedClientUser(res);
        resolve(res);
        return;
      }

      handleClearStoredAuth();
      if (hadCachedProfile && res?.Status?.status === 401) {
        ShowCustomErrorModal({
          message: "<p>Đã hết phiên đăng nhập</p>",
          title: "Phiên đăng nhập",
        });
      }
      resolve(null);
    });
  });

  setClientVerifyPromise(promise);
  return promise;
}
